export default __webpack_public_path__ + "static/media/logo.df478a32.png";